<template>
<div class="vertical-center-box">
  <!-- CLI 스크립트 수행 Popover -->
  <el-popover ref="scriptPopover" placement="left" trigger="click" width="600" :offset="40" @show="onShow">
    <div>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r4">스크립트 수행</div>
          <w-script-keyword-legend/>
        </div>
        <el-button type="primary" size="mini" @click="onExecuteScriptButtonClick">수행</el-button>
      </el-row>
      <el-input class="mr-b25" type="textarea" v-model="script" :rows="5" placeholder="스크립트 입력"></el-input>
      <!-- 스크립트 템플릿 -->
      <el-row class="title-bar" type="flex" justify="space-between">
        <el-select v-model="objCompanyId">
          <el-option v-for="item in vendorList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
        </el-select>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper ref="scriptTable" :data="tableData" height="250" row-class-name="c-pointer" :column-default="columnDefault"
      @condition-change="onTableConditionChange" :total="total" remote pagination @row-click="onScriptRowClick"
        :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool">
        <template slot-scope="scope" slot="testButton">
          <i class="fas fa-play-circle text-large c-pointer" @click="onDirectExecuteSciptButtonClick(scope.row)"/>
        </template>
      </el-table-wrapper>
    </div>
    <el-button slot="reference" style="border-top-right-radius: 0; border-bottom-right-radius: 0;" :size="size">CLI 스크립트</el-button>
  </el-popover>
  <!-- 라우팅 스크립트 관리 -->
  <el-button style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-left: -1px;" :size="size" icon="fas fa-cog" @click="onRoutingScriptManageButtonClick"></el-button>
  <w-routing-script-manage-popup ref="routingSciptManagePopup" @close="loadTemplate"/>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import netdeviceConfigApi from '@/api/config/netdevice/netdevice-info';
import netdeviceSettingApi from '@/api/settings/netdevice/netdevice-settings';
import WScriptKeywordLegend from '@/components/button/ScriptKeywordLegend';
import WRoutingScriptManagePopup from '../popup/RoutingScriptManagePopup';

export default {
  name: 'WExcecuteCliScriptButton',
  components: {
    WScriptKeywordLegend,
    WRoutingScriptManagePopup,
  },
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    size: {
      type: String,
      default: 'mini',
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      showSearchTool: false,
      columnDefault,
      objCompanyId: null,
      vendorList: [],
      tableData: [],
      total: 0,
      routingScriptTask: 'routingScriptTask',
      executedScriptJobSeq: null,
      script: '',
      columns: [
        {
          prop: 'templateName',
          width: 200,
          label: '스크립트명',
          remoteProp: 'nt.template_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'script',
          label: '스크립트',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          width: 50,
          prop: 'scriptTest',
          label: '수행',
          align: 'center',
          scopedSlot: 'testButton',
        },
      ],
    };
  },
  watch: {
    obj: {
      handler() {
        this.clear();
        this.removeExistRoutingScriptTask();
      },
    },
    objCompanyId: {
      handler() {
        this.loadTemplate();
      },
    },
    active: {
      handler(to) {
        if (!to) {
          this.removeExistRoutingScriptTask();
        }
      },
    },
  },
  beforeDestory() {
    this.removeExistRoutingScriptTask();
  },
  methods: {
    /**
     * 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clear() {
      this.script = null;
      this.executedScriptJobSeq = null;
    },
    /**
     * popover show 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onShow() {
      if (!isNil(this.obj)) {
        if (isNil(this.obj.objCompanyId)) {
          this.objCompanyId = this.obj.objCompanyId;
        }
        this.loadVendorList();
      }
    },
    /**
     * 네트워크 장비 벤더 목록을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadVendorList() {
      netdeviceSettingApi.getTemplateVendorList().then((response) => {
        if (response.data.success) {
          this.vendorList = response.data.data;
          if (isNil(this.objCompanyId)) {
            this.objCompanyId = this.vendorList[0].objCompanyId;
          }
          this.loadTemplate();
        }
      });
    },
    /**
     * 라우팅 템플릿을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadTemplate() {
      if (this.$refs.scriptTable) {
        this.loadRoutingTemplateScript();
      } else {
        this.$nextTick(() => {
          this.loadRoutingTemplateScript();
        });
      }
    },
    /**
     * 벤더에 대한 라우팅 템플릿 스크립트를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadRoutingTemplateScript() {
      const params = this.$refs.scriptTable.getParameter();
      params.objCompanyId = this.objCompanyId;
      this.loading = true;
      netdeviceConfigApi
        .getRoutingTemplateListOfVendor(params)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.tableData = result.data;
            this.total = result.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 스크립트', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 스크립트', false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 사용자가 입력한 스크립트를 수행한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onExecuteScriptButtonClick() {
      this.scriptName = null;
      this.excecuteScript();
    },
    /**
     * 스크립트를 즉시 수행한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onDirectExecuteSciptButtonClick(row) {
      this.script = row.script;
      this.scriptName = row.scriptName;
      this.excecuteScript();
    },
    /**
     * 스크립트를 수행한다.
     * @author Ju
     * @param  {[type]} script     [description]
     * @param  {[type]} scriptName [description]
     * @return {[type]}            [description]
     */
    excecuteScript() {
      if (isEmpty(this.script)) {
        this.$message(msgUtil.getRequireInfoMsg('설정', '스크립트'));
        return;
      }
      const objIds = [this.obj.objId];

      this.$emit('start-execute-script');
      this.executedScriptJobSeq = null;
      this.$refs.scriptPopover.doClose();
      netdeviceConfigApi.executeScript({
        objIds,
        script: this.script,
        scriptName: this.scriptName,
      }).then((result) => {
        const jobSeq = result.data.data;
        this.$taskManager.createTask(this.routingScriptTask, 5, () => {
          netdeviceConfigApi.getExecuteProgressRate({
            jobSeq,
          }).then((progressResult) => {
            const progressRate = progressResult.data.data;
            if (progressRate === 1) {
              this.$taskManager.removeTask(this.routingScriptTask);
              this.getScriptResult(jobSeq);
            }
          }).catch(() => {
            this.failToExecuteScript();
          });
        }, false, 100, () => {
          this.$taskManager.removeTask(this.executeScriptTask);
          this.completeExceuteScript(false, null, '시간 초과로 스크립트 수행 결과를 조회하지 못하였습니다.');
        });
        this.$taskManager.startTask(this.routingScriptTask);
      }).catch(() => {
        this.failToExecuteScript();
      });
    },
    /**
     * 스크립트 수행 결과를 조회한다.
     * @author Ju
     * @param  {[type]} jobSeq [description]
     * @return {[type]}        [description]
     */
    getScriptResult(jobSeq) {
      netdeviceConfigApi.getExecuteScriptResult({ jobSeq }).then((response) => {
        if (response.data.success) {
          this.executedScriptJobSeq = jobSeq;
          const data = response.data.data;
          if (isEmpty(data) || isEmpty(data[0].convertedJobResult)) {
            this.completeExceuteScript(true, null, '스크립트 수행 결과가 없습니다.');
          } else {
            const result = data[0].convertedJobResult.replace(/\n\n/g, '/n');
            this.completeExceuteScript(true, result, null);
          }
        } else {
          this.failToExecuteScript();
        }
      }).catch(() => {
        this.failToExecuteScript();
      });
    },
    /**
     * 스크립트 수행 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToExecuteScript() {
      this.completeExceuteScript(false, null, msgUtil.getResultMsg('수행', '스크립트', false));
    },
    /**
     * 스크립트 수행 완료 처리
     * @author Ju
     * @param  {[type]} success [description]
     * @param  {[type]} data    [description]
     * @param  {[type]} message [description]
     * @return {[type]}         [description]
     */
    completeExceuteScript(success, data, message) {
      this.$emit('end-execute-script', success, data, message);
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onTableConditionChange() {
      this.loadTemplate();
    },
    /**
     * 스크립트 row 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onScriptRowClick(row) {
      this.script = row.script;
    },
    /**
     * 공백 데이터 처리를 위한 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 라우팅 스크립트 관리 팝업을 연다.
     * @author Ju
     * @return {[type]} [description]
     */
    onRoutingScriptManageButtonClick() {
      const objCompanyId = isNil(this.objCompanyId) ? this.obj.objCompanyId : this.objCompanyId;
      this.$refs.routingSciptManagePopup.open(objCompanyId);
    },
    /**
     * 스크립트 수행 결과를 엑셀로 출력한다.
     * @author Ju
     * @return {[type]} [description]
     */
    exportScriptResult() {
      if (isNil(this.executedScriptJobSeq)) {
        this.$message(msgUtil.getRequireInfoMsg('수행', '스크립트'));
        return;
      }
      netdeviceConfigApi.exportRoutingScriptResult({ jobSeq: this.executedScriptJobSeq, objId: this.obj.objId });
    },
    removeExistRoutingScriptTask() {
      if (this.$taskManager.existTask(this.routingScriptTask)) {
        this.$taskManager.removeTask(this.routingScriptTask);
        this.$emit('end-execute-script');
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/components/ExcecuteCliScriptButton.vue